/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pdc_Action_EditInputs */

const vi_pdc_action_edit = /** @type {(inputs: Pdc_Action_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sửa`)
};

/**

* @param {Pdc_Action_EditInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pdc_action_edit = /** @type {((inputs?: Pdc_Action_EditInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pdc_Action_EditInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pdc_action_edit(inputs)
});